<div class="logged-in-profile">
    <!-- Infos user (employee, student, parent) -->
    <div class="infos" *ngIf="user">
        <div class="row info-line">
            <div class="col-md-4"><span class="icon i-shield"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.ROLE' | translate }}</div>
            <div class="col-md-8">
                <ng-container *ngFor="let role of user.role">
                    {{ 'ENUM.ROLES.' + role.type.toUpperCase() | translate | titlecase }}
                </ng-container>
            </div>
        </div>

        <div class="row info-line" *ngIf="user.email">
            <div class="col-md-4"><span class="icon i-at"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.MAIL' | translate }}</div>
            <div class="col-md-8">
                {{ user.email }}
            </div>
        </div>
        <div class="row info-line" *ngIf="user.homeNumber">
            <div class="col-md-4"><span class="icon i-phone"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.PHONE' | translate }}</div>
            <div class="col-md-8">
                {{ user.homeNumber }}
            </div>
        </div>
        <div class="row info-line" *ngIf="user.mobileNumber">
            <div class="col-md-4"><span class="icon i-mobile"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.MOBILE' | translate }}</div>
            <div class="col-md-8">
                {{ user.mobileNumber }}
            </div>
        </div>
        <div class="row info-line" *ngIf="user.address && user.address.street">
            <div class="col-md-4"><span class="icon i-home"></span>{{ 'REPERTOIRE.CONTACTS.PROFILE.ADDRESS' | translate }}</div>
            <div class="col-md-8">
                {{ user.address.street }} {{ user.address.home_number + (user.address.box ? '/' + user.address.box : '') }}<br />
                {{ user.address.additional_information }}<br *ngIf="user.address.additional_information" />
                {{ user.address.postal_code }} {{ user.address.city }}<br />
                {{ user.address.country }}
            </div>
        </div>
    </div>
    <div class="actions">
        <!-- <a *ngIf="user" class="btn btn--primary" (click)="goToRoute('/messaging/new-message', { recipientId: user.id })">Contacter</a> -->
        <ng-container [ngSwitch]="type">
            <a class="btn btn--secondary" *ngSwitchCase="types.EMPLOYEE" (click)="goToRoute('/my-account/employee', { id: user.id })"
                >Editer</a
            >
            <a class="btn btn--secondary" *ngSwitchCase="types.PARENT" (click)="goToRoute('/my-account/parent', { id: user.id })">Editer</a>
        </ng-container>
    </div>
</div>
